var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondoBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 636,
    viewBox: "0 0 1280 636",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_35)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 518.5,
    cy: 462.5,
    r: 37.5,
    fill: "#D8FDDF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1264.5,
    cy: 322.5,
    r: 37.5,
    fill: "#D8FDDF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 103.5,
    r: 37.5,
    fill: "#D8FDDF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.5,
    cy: 76.5,
    r: 10.5,
    fill: "#D8FDDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 636,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoBanner);
export default __webpack_public_path__ + "static/media/fondo_banner.6284422150bea525a94b938635d84ee0.svg";
export { ForwardRef as ReactComponent };